import { ModusWcThemeSwitcher } from '@trimble-oss/moduswebcomponents-react';

interface ThemeSwitcherProps extends React.ComponentProps<typeof ModusWcThemeSwitcher> {
  /**
   * The theme to switch to.
   */
  theme: 'light' | 'dark' | 'auto';
}
export const ThemeSwitcher: React.FC<ThemeSwitcherProps> = (props) => {
  return <ModusWcThemeSwitcher {...props} />;
};

export default ThemeSwitcher;
